import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import TranslationText from '@Components/Utilities/TranslationText';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { contactType } from '@Components/Utilities/SandhillsConstants';
import CompareListing from '@Components/Compare/CompareListing';
import { tryDeleteCompareListingFromCookie } from '@Components/Utilities/CookieHelper';
const EmailModal = loadable(() => import('@Components/Shared/Modals/EmailModal'), true);
import { useState, useRef } from 'react';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const CompareView = (props) => {

    const [compareListings, setCompareListings] = useState(props.CompareListings);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [selectedInquiry, setSelectedInquiry] = useState('');
    const [selectedContactType, setSelectedContactType] = useState(contactType.Retail);
    const [SAMModel, setSAMModel] = useState(props.SAMModel)
    const ref = useRef([]);
    const [returnFocusRef, setReturnFocusRef] = useState({});
    const currentSite = useRecoilValue(atoms.currentWebsite);

    const deleteListing = (id) => {
        if (tryDeleteCompareListingFromCookie(id)) {
            let currentList = compareListings.filter(listing => listing.Id != id);
            setCompareListings(currentList);
        }
        else {
            alert(`${translator.translate('sandhills.tradesites.mvc.compareitemnotfound').toString()} ${translator.translate('sandhills.tradesites.mvc.refreshandtryagain').toString()}`);
            window.location.reload();
        }
    };
    const onEmailModalToggle = () => {        
        setShowEmailModal(showEmailModal => !showEmailModal);
        if (returnFocusRef) {
            returnFocusRef.focus();
        }
    };

    const openEmailModal = (modalData) => {
        setSAMModel(() => {
            return {
                ...SAMModel,
                ...modalData
            };
        });

        setShowEmailModal(showEmailModal => !showEmailModal);
        setReturnFocusRef(modalData.Ref);
    };

    return (
        <div>
            <div className='bread-crumbs-heading'>
                <div>
                    <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.PageTitle} />
                    {!currentSite.IsMobileAppContext &&
                        <div className='return-links'>
                            <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); window.history.go(-1) } }} onClick={() => window.history.go(-1)} id='return-to-listings-link' className='return-links-link'>
                                <i className='fa fa-arrow-left' />
                                <span><TranslationText tKey='sandhills.returntopreviouspagestatic' /></span>
                            </a>
                            {!props.IsHostedSite &&
                                <a href={props.ListingsUrl} id='view-all-listings-compare-link' className='return-links-link'>
                                    <i className='fa fa-arrow-left' />
                                    <span><TranslationText tKey='sandhills.tradepubwebsite.mvc.viewall' /> <TranslationText tKey='sandhills.tradepubwebsite.mvc.listings' /></span>
                                </a>}
                        </div>
                    }
                </div>
                <div className='title-media-buttons-heading'>
                    <h1><TranslationText tKey='sandhills.tradesites.mvc.comparelistings' /></h1>
                    <div className='media-buttons'>
                        <button id='compare-page-print-this' className='ts-button print-this des-print-this' onClick={() => window.print()}><i className='fas fa-print' /> <TranslationText tKey='sandhills.print' /> </button>
                    </div>
                </div>
            </div>
            {compareListings && compareListings.length > 0 ?
                <div className='compare-listings-container'>
                    {compareListings.map(obj =>
                        <CompareListing
                            key={obj.Id}
                            {...obj}
                            ImageIconUrl={props.ImageIconUrl}
                            VideoIconUrl={props.VideoIconUrl}
                            DeleteListing={deleteListing}
                            openEmailModal={openEmailModal}
                            ref={ref}
                            IsRY={currentSite?.Site?.IsRentalYard}
                        />)}
                </div>
                :
                <div id='no-compare-listings' style={{ display: 'block' }} >
                    <h2><TranslationText tKey='sandhills.nolistingstocompare' /></h2>
                    {!props.IsHostedSite &&
                        <h3><a href={props.ListingsUrl}><TranslationText tKey='sandhills.searchforlistingstocompare' /></a></h3>}
                </div>}
            {showEmailModal &&
                <EmailModal
                    {...SAMModel}
                    CurrencySelector={props.CurrencySelector}
                    toggleEmailModal={onEmailModalToggle}
                    selectedInquiry={selectedInquiry}
                    selectedContactType={selectedContactType}
                    DefaultCultureCode={props.CurrencySelector.DefaultCultureCode}
                />}
        </div>
    );
};

export default CompareView;
global.CompareView = CompareView;